<template>
  <div class="ac-body-container">
    <div class="ac-content-container">
      <div class="header">
        Choose Homeowner tune-up intervals:
      </div>
      <SACRadio
        name="maintenance"
        field="interval"
        value="6"
        :checked="interval === '6'"
        :change="onChange"
        label="Every 6 months"
        :disable="adminRole !== 'admin'"
      />
      <SACRadio
        name="maintenance"
        field="interval"
        value="12"
        :checked="interval === '12'"
        :change="onChange"
        label="Annually"
        :disable="adminRole !== 'admin'"
      />
      <SACRadio
        name="maintenance"
        field="interval"
        value="24"
        :checked="interval === '24'"
        :change="onChange"
        label="Every two years"
        :disable="adminRole !== 'admin'"
      />
      <div>
        <SACRadio
          name="maintenance"
          field="interval"
          value="custom"
          :checked="interval === 'custom'"
          :change="onChange"
          label="Custom"
          :disable="adminRole !== 'admin'"
        />
        <div
          v-if="interval === 'custom'"
          class="body"
        >
          Months between tune-ups
        </div>
        <SACInput
          v-if="interval === 'custom'"
          field="custom"
          type="number"
          :value="custom"
          :change="onChange"
          :error="errorObj.customErr"
          :disable="adminRole !== 'admin'"
        />
      </div>
      <SACRadio
        name="maintenance"
        field="sendReminder"
        :value="sendReminder"
        :checked="sendReminder === 'No'"
        :change="onChange"
        label="Don't send homeowners tune-up reminders"
        :disable="adminRole !== 'admin'"
      />
    </div>
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

import SACInput from '@shared/components/sac/SACInput.vue';
import SACRadio from '@shared/components/sac/SACRadio.vue';

export default {
  name: 'MaintenanceSection',
  components: {
    SACInput,
    SACRadio,
  },
  mixins: [partnerSettingsMixin],
  props: {
    interval: String,
    sendReminder: String,
    custom: String,
    onChange: Function,
    errorObj: Object,
  },
};
</script>

<style lang="scss" scoped>

.header {
  font-size: 1rem;
  font-weight: 700;
  color: $N80;
}
.sub-header {
  font-size: 1rem;
  font-weight: 500;
  color: $N60;
}
.ac-content-container {
  &:not(:last-child) {
    padding-bottom: 18px;
    margin-bottom: 18px;
    border-bottom: 2px solid $N20;
  }
}
.ac-input-container, .sac-radio-container {
  margin-top: 12px;
  margin-bottom: 0 !important;
}
.body {
  font-size: 0.875rem;
  margin-top: 8px;
  margin-bottom: 8px;
  color: $N80;
}
.sub-label {
  font-size: 1rem;
  font-weight: 500;
  color: $N60;
  max-width: 600px;
}
</style>
